import { brandSeoMap } from "../config/brandSeo";
import {
  defaultBrandSeoDescription,
  defaultBrandSeoTitle,
  type SeoMeta,
} from "../config/pageSeo";

export const normalizeStoreKey = (store: string | null | undefined) =>
  (store || "")
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/$/, "");

export const getBrandSeoMeta = (
  store: string | null | undefined,
  apiTitle: string | null | undefined,
  apiDescription: string | null | undefined,
): SeoMeta => {
  const normalizedStore = normalizeStoreKey(store);
  const custom =
    normalizedStore && brandSeoMap[normalizedStore]
      ? brandSeoMap[normalizedStore]
      : null;

  return {
    title: custom?.title ?? apiTitle ?? defaultBrandSeoTitle,
    description:
      custom?.description ?? apiDescription ?? defaultBrandSeoDescription,
  };
};

const clampDescription = (value: string) => {
  const text = value.replace(/\s+/g, " ").trim();
  if (text.length <= 160) return text;
  const shortened = text.slice(0, 157);
  const lastSpace = shortened.lastIndexOf(" ");
  return `${(lastSpace > 80 ? shortened.slice(0, lastSpace) : shortened).trim()}...`;
};

export const getPartnerBoostSeoMeta = (
  name: string | null | undefined,
  siteDescription: string | null | undefined,
): SeoMeta => {
  const brandName = (name || "").trim() || "Brand";
  const rawDescription = (siteDescription || "").trim();
  const description =
    rawDescription.length >= 40 && !/^default\s*:/i.test(rawDescription)
      ? clampDescription(rawDescription)
      : `Find the latest ${brandName} promo codes, coupons and deals. Save with verified discounts and updated offers.`;

  return {
    title: `${brandName} Promo Codes and Coupons`,
    description,
  };
};
